import Row from '@amzn/meridian/row';
import React, { FC } from 'react';
import { Button, TranslationFunction } from '../../../components/blocks/localization';

// The review page's Cancel and Submit actions.

export type PoReviewFooterActionsProps = {
    t: TranslationFunction;
    isSubmitDisabled: boolean;
    isSubmitBusy: boolean;
    onCancel: () => void;
    onSubmit: () => void;
    dataTestIdPrefix: string;
};

const PoReviewFooterActions: FC<PoReviewFooterActionsProps> = ({
    t,
    isSubmitDisabled,
    isSubmitBusy,
    onCancel,
    onSubmit,
    dataTestIdPrefix,
}) => (
    <Row alignmentHorizontal={'right'}>
        <Button type={'secondary'} onClick={onCancel} data-testid={`${dataTestIdPrefix}.cancelButton`}>
            {t('cancel-buttonLabel')}
        </Button>
        <Button
            type={'primary'}
            disabled={isSubmitDisabled}
            isBusy={isSubmitBusy}
            onClick={onSubmit}
            data-testid={`${dataTestIdPrefix}.submitButton`}
        >
            {t('submitPurchaseOrder-buttonLabel')}
        </Button>
    </Row>
);

export { PoReviewFooterActions };
